/**
 * Best Sellers Manager - Moon Moon Agency
 * Gère le switch de collection via les pills (tabs)
 */

/*********************************************************************************************
 * 🛍️ BEST SELLERS MANAGER
 *
 * Guarded against double-init: this file is loaded both from sections/MM-Best-Sellers.liquid
 * and blocks/hm-news.liquid, which can both land on the same page. A bare top-level `const`
 * would throw "Identifier already declared" the second time the script runs, so the manager
 * is exposed on `window` and only ever declared once.
 */
if (!window.BestSellersManager) {

window.BestSellersManager = {
	config: {
		selectors: {
			section: '.mm-best-sellers',
			tab: '[data-bs-tab]',
			panel: '.mm-best-sellers__panel',
			slider: '.mm-best-sellers__slider',
		},
		classes: {
			pillActive: 'mm-best-sellers__pill--active',
			panelHidden: 'mm-best-sellers__panel--hidden',
		},
	},

	init() {
		const sections = window.getElements(this.config.selectors.section);
		if (!sections.length) return;

		sections.forEach(section => this._initTabs(section));
		window.log('info', '🛍️ [BEST_SELLERS]', 'Initialized');
	},

	/* -------------------------------------------------------------------------
	 * Mode tabs (collections)
	 * ----------------------------------------------------------------------- */

	_initTabs(section) {
		const tabs = section.querySelectorAll(this.config.selectors.tab);
		if (!tabs.length) return;

		tabs.forEach((tab, index) => {
			tab.addEventListener('click', () => this._onTabClick(section, tab, tabs));
			tab.addEventListener('keydown', e => this._onTabKeydown(e, section, tabs, index));
		});
	},

	_onTabKeydown(e, section, tabs, index) {
		const keyToIndex = {
			ArrowRight: (index + 1) % tabs.length,
			ArrowLeft: (index - 1 + tabs.length) % tabs.length,
			Home: 0,
			End: tabs.length - 1,
		};

		const nextIndex = keyToIndex[e.key];
		if (nextIndex === undefined) return;

		e.preventDefault();
		const nextTab = tabs[nextIndex];
		nextTab.focus();
		this._onTabClick(section, nextTab, tabs);
	},

	_onTabClick(section, tab, tabs) {
		const key = tab.dataset.bsTab;
		const panel = section.querySelector(`#mm-bs-panel-${key}`);
		if (!panel) return;

		tabs.forEach(t => {
			t.classList.remove(this.config.classes.pillActive);
			t.setAttribute('aria-selected', 'false');
			t.setAttribute('tabindex', '-1');
		});

		section.querySelectorAll(this.config.selectors.panel).forEach(p => {
			p.classList.add(this.config.classes.panelHidden);
		});

		tab.classList.add(this.config.classes.pillActive);
		tab.setAttribute('aria-selected', 'true');
		tab.setAttribute('tabindex', '0');
		panel.classList.remove(this.config.classes.panelHidden);

		this._mountSplide(panel.querySelector(this.config.selectors.slider));
	},

	_mountSplide(splideEl) {
		if (!splideEl) return;

		if (splideEl._splide) {
			splideEl._splide.refresh();
			return;
		}

		if (typeof Splide === 'undefined') return;

		try {
			const config = JSON.parse(splideEl.dataset.splide || '{}');
			splideEl._splide = new Splide(splideEl, config).mount();
			window.log('info', '🛍️ [BEST_SELLERS]', 'Splide mounted');
		} catch (e) {
			window.log('error', '🛍️ [BEST_SELLERS]', 'Splide mount failed', { error: e.message });
		}
	},
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => window.BestSellersManager.init());
} else {
	window.BestSellersManager.init();
}

}
